import $ from "jquery";

const shop = () => {
  const init = () => {
    (async () => {
      await filterFold();
      await isOpenFilterFold();
    })();

    filterOnMobile();
  };

  const filterFold = () => {
    const el = {
      parent: ".js-FilterShop",
      li: ".js-FilterShop .wpf_links li",
      toggleEl: ".js-FilterToggle",
    };

    if ($(el.parent).length === 0) return;

    // add class mi-HasChild
    $(`${el.li} ul`).parent().addClass("mi-HasChild");
    $(`${el.li} ul`)
      .parent()
      .prepend(
        `<span class="${el.toggleEl.substring(
          1
        )} mi-FilterToggle"><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 6L6 1L11 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg></span>`
      );

    $(document).on("click", el.toggleEl, function () {
      $(this).parent().toggleClass("isOpen");
      $(this).siblings("ul").toggle(300);
    });
  };

  const isOpenFilterFold = () => {
    const el = {
      isOpen: ".js-FilterShop .wpf_links li ul span.wpf_selected",
    };

    if ($(el.isOpen).length === 0) return;

    $(el.isOpen).parent().parent().parent().addClass("isOpen");
    $(el.isOpen).parent().parent().show();
  };

  const filterOnMobile = () => {
    const el = {
      filter: ".js-FilterShop",
      btn: ".js-BtnMobileFilterFloat",
      mobileFilter: ".js-MobileFilterFloat",
    };

    if ($(el.filter).length === 0 || window.screen.width > 1024) return;

    $(window).on("load", function () {
      $(el.filter)
        .parent()
        .addClass("js-MobileFilterFloat mi-MobileFilterFloat");
      $(el.filter).after(
        `<button class="js-BtnMobileFilterFloat mi-BtnMobileFilterFloat"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.6727 0.952637H2.01894C0.978022 0.952637 0.452778 2.21563 1.19033 2.95317L10.2207 11.9849V22.0464C10.2207 22.4288 10.4073 22.7871 10.7206 23.0064L14.6268 25.7398C15.3975 26.2793 16.4707 25.7326 16.4707 24.7798V11.9849L25.5013 2.95317C26.2373 2.21709 25.7157 0.952637 24.6727 0.952637Z" fill="black"/></svg></button>`
      );
    });

    $(document).on("click", el.btn, function () {
      $(el.mobileFilter).toggleClass("isOpen");
    });
  };

  init();
};

try {
  shop();
} catch (e) {
  console.error(e);
}
